module.exports = __webpack_public_path__ + "static/media/punk_female.a7c1f871.png";